import { some } from "lodash";
import { getFirebaseDB } from "../../services/firebase";
import notificationService from "../../services/notification";

const notification = {
	namespaced: true,
  state: {
    notifications: null,
    currentfrontendTech: null,
    notificationConfig: null
  },
  actions: {
    GET_NOTIFICATIONS(store, {id}) {
      getFirebaseDB('Notifications').child(`usr-${id}`).on('value', snapshot => {
        store.commit('SET_NOTIFICATIONS', []);
        snapshot.forEach(doc => {
          if (doc.val().type == 1 || doc.val().type == 3) {
            store.commit('UPDATE_NOTIFICATION', doc.val());
          }
        })
      })
    },
    UPDATE_NOTIFICATION(store, newNotif) {
      store.commit('UPDATE_NOTIFICATION', newNotif);
    },
    UPDATE_CURRENT_FRONTEND_TECH(store, currentfrontendTech) {
     store.commit('UPDATE_CURRENT_FRONTEND_TECH', currentfrontendTech)
    },
    GET_NOTIFICATION_CONFIG(store) {
      notificationService.getNoticonfig().then((res)=> {
        store.commit('SET_NOTIFICATION_CONFIG', res)

      })
     }
  },
  mutations: {
    SET_NOTIFICATIONS: (state, notifications) => {
      state.notifications = notifications;
    },
    UPDATE_NOTIFICATION: (state, newNotif) => {
      state.notifications.unshift(newNotif);
    },
    UPDATE_CURRENT_FRONTEND_TECH: (state, currentfrontendTech) => {
      state.currentfrontendTech = currentfrontendTech;
    },
    SET_NOTIFICATION_CONFIG(state,config) {
      state.notificationConfig = config
    }
  },
  getters: {
    notifications: (state) => state.notifications,
    unreadNotifs: (state) => state.notifications && (state.notifications.filter(notif => !notif.isRead)),
    notificationConfig: (state) => state.notificationConfig
  }
};

export default notification;
